module.exports = __webpack_public_path__ + "static/media/07.b152cce0.jpg";